import {
    UPDATEMODULEALLOCATIONLISTFORADMIN_SUCCESS,
    UPDATEMODULEALLOCATIONLISTFORADMIN_FAILED,
    RESET_UPDATEMODULEALLOCATIONLISTFORADMIN,
    LOADING_UPDATEMODULEALLOCATIONLISTFORADMIN,
    NETWORK_ERROR_UPDATEMODULEALLOCATIONLISTFORADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetUpdateModuleAllocationListAdmin = () => {
    return { type: RESET_UPDATEMODULEALLOCATIONLISTFORADMIN };
};

const AdminUpdateModuleAllocationList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEMODULEALLOCATIONLISTFORADMIN });
    await adminServices
        .post("updateModuleAllocationListforAdmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(updateModuleAllocationListAdminsuccess(res.data));
                    break;
                default:
                    dispatch(updateModuleAllocationListAdminFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_UPDATEMODULEALLOCATIONLISTFORADMIN,
                payload: err
            });
        });
};


function updateModuleAllocationListAdminsuccess(data) {
    return {
        type: UPDATEMODULEALLOCATIONLISTFORADMIN_SUCCESS,
        payload: data
    };
}
function updateModuleAllocationListAdminFailed(data) {
    return {
        type: UPDATEMODULEALLOCATIONLISTFORADMIN_FAILED,
        payload: data
    };
}

export { AdminUpdateModuleAllocationList, resetUpdateModuleAllocationListAdmin }